var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnlockOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.375 22q-.774 0-1.324-.56a1.85 1.85 0 0 1-.551-1.345v-9.524q0-.785.55-1.345.552-.56 1.325-.56h8.438V6.763q0-1.19-.82-2.024A2.7 2.7 0 0 0 12 3.905a2.63 2.63 0 0 0-1.723.607 2.97 2.97 0 0 0-.996 1.512.95.95 0 0 1-.386.536 1.1 1.1 0 0 1-.645.202.92.92 0 0 1-.668-.262.64.64 0 0 1-.2-.619Q7.713 4.238 9 3.119A4.44 4.44 0 0 1 12 2q1.945 0 3.316 1.393 1.371 1.392 1.371 3.369v1.905h.938q.774 0 1.324.56.55.558.551 1.344v9.524q0 .786-.55 1.346-.552.56-1.325.559zm0-1.905h11.25v-9.524H6.375zM12 17.238q.774 0 1.324-.56.55-.558.551-1.345 0-.786-.55-1.345a1.8 1.8 0 0 0-1.325-.56q-.774 0-1.324.56t-.551 1.345.55 1.346 1.325.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockOutline);
export default __webpack_public_path__ + "static/media/unlock_outline.bf390568434610ba89096e1be766e23d.svg";
export { ForwardRef as ReactComponent };